/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Booking_Lessons_CountInputs */

const en_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} lessons)`)
};

const es_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} lecciones)`)
};

const de_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} Golfstunden)`)
};

const zh_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`（${i?.count} 节课）`)
};

const ar_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(عدد الدروس: ${i?.count})`)
};

const fr_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} cours)`)
};

const vi_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} buổi)`)
};

const sw_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(masomo ${i?.count})`)
};

const th_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} ครั้ง)`)
};

const bs_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} lekcija)`)
};

const ja_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count}レッスン)`)
};

const ko_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count}회 레슨)`)
};

const pt_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} aulas)`)
};

const it_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} lezioni)`)
};

const sv_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} lektioner)`)
};

const nl_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} lessen)`)
};

const da_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} lektioner)`)
};

const nb_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} leksjoner)`)
};

const fi_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} golftuntia)`)
};

const pl_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(lekcje: ${i?.count})`)
};

const ru_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} уроков)`)
};

const tr_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} ders)`)
};

const hi_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} पाठ)`)
};

const id_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} pelajaran)`)
};

const ms_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} pelajaran)`)
};

const cs_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} lekcí)`)
};

const el_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} μαθήματα)`)
};

const he_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} שיעורים)`)
};

const af_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} lesse)`)
};

const hu_booking_lessons_count = /** @type {(inputs: Booking_Lessons_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} óra)`)
};

/**
* | output |
* | --- |
* | "({count} lessons)" |
*
* @param {Booking_Lessons_CountInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_lessons_count = /** @type {((inputs: Booking_Lessons_CountInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Lessons_CountInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_lessons_count(inputs)
	if (locale === "de") return de_booking_lessons_count(inputs)
	if (locale === "zh") return zh_booking_lessons_count(inputs)
	if (locale === "ar") return ar_booking_lessons_count(inputs)
	if (locale === "fr") return fr_booking_lessons_count(inputs)
	if (locale === "vi") return vi_booking_lessons_count(inputs)
	if (locale === "sw") return sw_booking_lessons_count(inputs)
	if (locale === "th") return th_booking_lessons_count(inputs)
	if (locale === "bs") return bs_booking_lessons_count(inputs)
	if (locale === "ja") return ja_booking_lessons_count(inputs)
	if (locale === "ko") return ko_booking_lessons_count(inputs)
	if (locale === "pt") return pt_booking_lessons_count(inputs)
	if (locale === "it") return it_booking_lessons_count(inputs)
	if (locale === "sv") return sv_booking_lessons_count(inputs)
	if (locale === "nl") return nl_booking_lessons_count(inputs)
	if (locale === "da") return da_booking_lessons_count(inputs)
	if (locale === "nb") return nb_booking_lessons_count(inputs)
	if (locale === "fi") return fi_booking_lessons_count(inputs)
	if (locale === "pl") return pl_booking_lessons_count(inputs)
	if (locale === "ru") return ru_booking_lessons_count(inputs)
	if (locale === "tr") return tr_booking_lessons_count(inputs)
	if (locale === "hi") return hi_booking_lessons_count(inputs)
	if (locale === "id") return id_booking_lessons_count(inputs)
	if (locale === "ms") return ms_booking_lessons_count(inputs)
	if (locale === "cs") return cs_booking_lessons_count(inputs)
	if (locale === "el") return el_booking_lessons_count(inputs)
	if (locale === "he") return he_booking_lessons_count(inputs)
	if (locale === "af") return af_booking_lessons_count(inputs)
	if (locale === "hu") return hu_booking_lessons_count(inputs)
	return en_booking_lessons_count(inputs)
});